<template>
  <div id="app" :class="(show_side_menu ? 'menu_open ' : '' ) + 'rtl theme_' + theme">
    
    <!-- Unpublished page - minimal layout -->
    <template v-if="isUnpublishedPage">
      <main id="page-wrap" v-if="loaded">
        <div id="page_content">
          <Unpublished :key="$route.path" />
          <ItemWidget v-if="widget_item !== false" :item="widget_item" :key="'wid' + widget_item.id" @close="widget_item=false; play_item=false" @playItem="play" />
          <FooterPlayer v-if="play_item !== false /*&& $route.name != 'item'*/" :item="play_item.item" :playlist="play_item.playlist" :key="playerKey" :autoplay="play_item.autoplay"  @open_widget="open_widget" @close="widget_item=false; play_item=false" :isInWidget="widget_item != false" />

        </div>
      </main>
    </template>

    <!-- Auth pages (signup) - minimal layout, no header/bar -->
    <template v-else-if="isAuthPage">
      <main id="page-wrap" class="no_header" v-if="loaded">
        <div id="page_content">
          <router-view :key="$route.path"></router-view>
        </div>
      </main>
    </template>
    
    <!-- Regular layout -->
    <template v-else>
      <main id="page-wrap" v-if="loaded">
        <div id="header_mobile"  v-if="is_mobile()">
              <router-link to="/" class="logo_mobile"></router-link>
               <div id="user_pic" @click="show_user_popup=!show_user_popup" :style="'background-image:url('+user_data.pic_parsed+')'"></div>
                  <div id="user_popup" v-show="show_user_popup">
                  <ul>
                    <li><router-link to="/settings">אזור אישי</router-link></li>
                    <li><a @click="logout()">יציאה</a></li>
                  </ul>
                  </div> 
              
                <div id="menu_hamburger" v-on:click="show_side_menu=!show_side_menu">
                <div id="nav-icon3"><span></span><span></span><span></span><span></span></div>
              </div>
            </div>
            <div id="side_menu" v-if="is_mobile()">
                 <router-link to="/" id="logo"></router-link>

        <div class="lnk_switch">
          <a :class="(theme == 'light' ? 'active' : '')" @click="change_theme('light')">בהיר</a>
          <a :class="(theme == 'dark' ? 'active' : '')" @click="change_theme('dark')">כהה</a>
        </div>
        <div id="bar_menu">
          <ul>
            <li v-for="item in menu_mobile" :key="item.link" :class="($route.path == item.link ? 'acitve' : '')">
              <template v-if="item.target == '_blank'"><a target="_blank" :href="item.link"><i :style="'background-image: url(' + item.icon  + ')'"></i><span v-text="item.name"></span></a></template>
              <template v-else><router-link :to="item.link" @click.prevent="show_side_menu=false; "><i :style="'background-image: url(' + item.icon  + ')'"></i><span v-text="item.name"></span></router-link></template>
            </li>
          </ul>
        </div>
            </div>
        <div id="page_content">
              <Header v-if="showMainHeader" :user_data="user_data" :searcProps="searcProps" :num_unreaded="num_unreaded" />
              
              <Bar :user_data="user_data" :theme="theme" @change_theme="change_theme" :playlists="playlists" @addPlaylist="addPlaylist" />

              <router-view :user_data="user_data" :num_unreaded="num_unreaded" :theme="theme" :key="$route.path" @show_loader="show_loader=true" @loaded="show_loader=false" @open_widget="open_widget" @play="play" @playPlaylist="playPlaylist" @change_theme="change_theme" :searcProps="searcProps"></router-view>

              <ItemWidget v-if="widget_item !== false" :item="widget_item" :key="'wid' + widget_item.id" @close="widget_item=false; play_item=false" @playItem="play" />
              <FooterPlayer v-if="play_item !== false /*&& $route.name != 'item'*/" :item="play_item.item" :playlist="play_item.playlist" :key="playerKey" :autoplay="play_item.autoplay"  @open_widget="open_widget" @close="widget_item=false; play_item=false" :isInWidget="widget_item != false" />
              
              <div id="chats_wrapper" v-if="$route.name != 'Inbox'">
                <div v-for="chatId in open_chats" :key="chatId"><Chat :user_id="chatId" @close="close_chat(chatId)" ref="chatbox"  /></div>
              </div>

              <Share />
              
              <AddToPlaylist :playlists="playlists" />

              <CreateLinktoneInvite v-if="showLinktoneInvite" @close="dismissLinktoneInvite" @go="goToLinktones" />
        </div>
      </main>
    </template>
    
    <div v-if="!loaded || show_loader" id="app_loading">
      <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
    </div>
<link rel="stylesheet" href="//fonts.googleapis.com/css?family=Roboto:400,500,700,400italic|Material+Icons">

  </div>
</template>

<script>
import Header from './components/header.vue'
import Bar from './components/bar.vue'
import ItemWidget from './components/item_widget/index.vue';
import FooterPlayer from './components/catalog/FooterPlayer.vue';
import Chat from './components/chat.vue'
import Share from './components/share.vue'
import AddToPlaylist from './components/AddToPlaylist.vue'
import CreateLinktoneInvite from './components/CreateLinktoneInvite.vue'
import Unpublished from './views/unpublished.vue';

export default {
  name: 'app',
  components: {
    Header, Bar, ItemWidget, FooterPlayer, Chat, Share, AddToPlaylist, CreateLinktoneInvite, Unpublished
  },
  data(){
    return {
      myLinktonesSubview: 'list',
      num_unreaded: 0,
      open_chats: [],
        show_user_popup: false,
      searcProps: {
        genres: [],
        genres_show: false,
        type: false,
        is_album: false,
        mixed_results: true,
        date_from: null,
        date_to: null,
        q: ''
      },
       menu_mobile: [
        {name: 'ראשי', link: '/' , icon: require('@/assets/menu_inbox.svg')},
        {name: 'בשבילך', link: '/dashboard', icon: require('@/assets/menu_personal.svg')},
        {name: 'אהבתי', link: '/likes', icon: require('@/assets/menu_personal.svg')},
        {name: 'לינקיפדיה', link: '/linkipedia' , icon: require('@/assets/menu_linkipedia.svg')},
        {name: 'המצעד', link: '/parade' , icon: require('@/assets/menu_mitzad.svg')},
        {name: 'הודעות', link: '/inbox' , icon: require('@/assets/menu_inbox.svg')},
        {name: 'הגדרות', link: '/settings' , icon: require('@/assets/menu_settings.svg')},
        {name: 'תקליט', link: 'https://taklit.cc/', target: '_blank', icon: require('@/assets/menu_settings.svg')},
      ],
      show_side_menu: false,
      play_item: false,
      widget_item: false,
      user_data: {},
      playlists: [],
      loaded: false,
      show_loader: false,
      theme: 'light',
      showLinktoneInvite: false,
    }
    
  },
  computed: {
    /* Key for FooterPlayer. It used to fall back to Math.random() whenever
       play_item had no `item` — which is exactly the playlist case, since
       playPlaylist() only sets `playlist`. A random key means a NEW key on every
       single App re-render, so the player was destroyed and rebuilt constantly;
       it assigns its plyr source inside a 300ms timeout in mounted(), so that
       timeout kept firing on an instance that was already gone and the source
       was never actually set. Hence: a playlist never played, while the catalog
       (which does pass `item`, so the key was stable) played fine.
       playlist.vue re-emits the array with the chosen track first, so keying on
       that track's id is stable while it plays and changes when another is picked. */
    playerKey() {
      if (this.play_item === false) return 'plyr';
      if (!this.isNull(this.play_item.item)) return 'plyr' + this.play_item.item.id;

      const list = this.play_item.playlist;
      const first = (list && list.length) ? list[0] : null;
      return 'plyr_pl_' + (first ? first.id : 'none');
    },
    showMainHeader() {
      if (this.$route.name === 'my_linktones' && this.myLinktonesSubview === 'wizard') {
        return false;
      }
      return true;
    },
    isAuthPage() {
      return ['signup', 'login', 'verifyEmail'].includes(this.$route.name);
    },
    isUnpublishedPage() {

      // first check the actual url from browser
      if (window.location.pathname.includes('/unpublished/'))
      {
        return true;
      }

      // then check the route name
      return this.$route.name === 'unpublished';
    }
  },
  methods: {
    reloadPage(){
      let getVars = {};
      let uri = window.location.href.split('?');
      if(uri.length == 2) {
        let vars = uri[1].split('&');
        
        let tmp = '';
        vars.forEach(function(v) {
          tmp = v.split('=');
          if(tmp.length == 2)
            getVars[tmp[0]] = tmp[1];
        });
        // do 
      }

      if(!this.isNull(getVars.token))
      {
        this.set_user_token(getVars.token);
        document.location = '/'
      }
      // categories 
      this.api({ action: 'general' }, (data) => { 
        this.$store.user = data.data.user;
        
        this.user_data = data.data.user;
        this.playlists = data.data.playlists;
        this.$store.genres = data.data.genres;
        this.$store.album_types = data.data.album_types;
        this.num_unreaded = data.data.num_unreaded;

        if (!(this.user_data.id > 0) && this.$route.name != 'item' && !this.isAuthPage)
        {
          this.goto('/login');
          return;
        }

        if (this.user_data.id > 0 && this.isAuthPage)
        {
          this.goto('/');
        }


        /* Pusher */
        var channel = this.$pusher.subscribe('user_cnl_' + this.user_data.id);
        channel.bind('allevents', (data) => {
    
          //this.$bus.$emit('new_push', data);
          this.parse_user_channel(data)
          //app.messages.push(JSON.stringify(data));
        });

        this.loaded = true;
        this.$nextTick(() => setTimeout(() => this.checkLinktoneInvite(), 2000));
      } );
    },
    addPlaylist(id, name){
      this.playlists.push({name: name, id: id});
    },
    play(item, autoplay) {
      if (item == false) this.play_item = false;
      else this.play_item = { item: item, autoplay: (autoplay !== false) };
    },
    playPlaylist(playerPlaylist) {
      this.play_item = { playlist: playerPlaylist, autoplay: true };
      console.log(playerPlaylist);
    },
    change_theme(theme)
    {
      this.theme = theme;
    },
    open_widget(item)
    {
      this.widget_item=item;
     // this.play_item = item;
    },

    close_chat(id){
      var index = this.open_chats.indexOf(id);
      if (index !== -1) {
        this.open_chats.splice(index, 1);
      }
    },
    
    checkLinktoneInvite() {
      if (this.$route.path !== '/') return;
      if (this.get_me().type !== 'artist') return;
      const last = parseInt(localStorage.getItem('linktone_invite_last_seen'));
      if (last && Date.now() - last < 86400000) return;
      this.showLinktoneInvite = true;
    },
    dismissLinktoneInvite() {
      localStorage.setItem('linktone_invite_last_seen', Date.now().toString());
      this.showLinktoneInvite = false;
    },
    goToLinktones() {
      this.dismissLinktoneInvite();
      this.goto('/my_linktones');
    },

    parse_user_channel(data)
    {
      switch(data.mtype)
      {
        case 'chat_msg': { 
          let exists = false;
          let openChats = document.querySelectorAll('.chat_wrapper');

          for (let i in openChats)
          {
            let chatbox = openChats[i];
            if (chatbox.dataset.id == data.data.uid_from)
            {
              exists = true;
              break;
            }
          }

          if (!exists)
          {
            this.open_chats.push(data.data.uid_from);
          }

          this.$bus.$emit('new-msg', data.data);

          break;
        }
      }
    },

  },
  mounted() {
    
    this.$bus.$on('open_widget', (item) => {
      this.open_widget(item);
    });

    
    this.$bus.$on('reload-page', () => {
      this.reloadPage()
    });

    this.$bus.$on('my_linktones:view', (subview) => {
      this.myLinktonesSubview = subview || 'list';
    });
    
    // window.appVue = this;
    this.$store.color_array = this.color_array
    this.$store.border_array =  this.border_array

    // For unpublished page, skip login and general API loading
    if (this.isUnpublishedPage || this.isAuthPage) {
      this.loaded = true;
      return;
    }

    if (!this.userToken)
    {
      this.loaded = true;
    }
    else
    {
      this.reloadPage();
    }
  },
  beforeUnmount() {
    this.$bus.$off('my_linktones:view');
  },
}
</script>